import React from "react";
import "./lang.css";

function Lang() {
  return (
    <>
      <div className="content">
        <div className="lang-1">
          <h3>Languages in India </h3>
          <p>
            {" "}
            Languages spoken in India belong to several language families, the
            major ones being the Indo-Aryan languages spoken by 78.05% of
            Indians and the Dravidian languages spoken by 19.64% of Indians.
            Languages spoken by the remaining 2.31% of the population belong to
            the Austroasiatic, Sino-Tibetan, Tai-Kadai and a few other minor
            language families and isolates. India has the world's second highest
            number of languages (780), after Papua New Guinea (839). Article 343
            of the Indian constitution stated that the official language of the
            Union is Hindi in Devanagari script instead of the extant English.
            Later, a constitutional amendment, The Official Languages Act, 1963,
            allowed for the continuation of English alongside Hindi in the
            Indian government indefinitely until legislation decides to change
            it. The form of numerals to be used for the official purposes of the
            Union are "the international form of Indian numerals", which are
            referred to as Arabic numerals in most English-speaking countries.
            Despite the misconceptions, Hindi is not the national language of
            India; the Constitution of India does not give any language the
            status of national language.
          </p>
        </div>
        <div className="lang-2">
          <div className="lang-card">
            <h2>Name of State </h2>
            <h3>Jammu and Kashmir </h3>
            <h3>Himachal Pradesh </h3>
            <h3>Punjab</h3>
            <h3>Uttrakhand </h3>
            <h3>Haryana </h3>
            <h3>Delhi </h3>
            <h3>Uttar Pradesh </h3>
            <h3>Rajasthan </h3>
            <h3>Madhya Pradesh </h3>
            <h3>Chhattisgarh </h3>
            <h3>Bihar </h3>
            <h3>Jharkhand </h3>
            <h3>West Bengal </h3>
            <h3>Sikkim </h3>
            <h3>Assam </h3>
            <h3>Arunachal Pradesh </h3>
            <h3>Nagaland </h3>
            <h3>Mizoram </h3>
            <h3>Tripura</h3>
            <h3>Meghalaya </h3>
            <h3>Manipur </h3>
            <h3>Odisha </h3>
            <h3>Maharashtra </h3>
            <h3>Gujarat</h3>
            <h3>Daman and Diu </h3>
            <h3>Dadra and Nagar Haveli </h3>
            <h3>Goa</h3>
            <h3>Karnataka </h3>
            <h3>Andhra Pradesh </h3>
            <h3>Kerala </h3>
            <h3>Lakshadweep Islands </h3>
            <h3>Tamil Nadu </h3>
            <h3>Puducherry </h3>
            <h3>Andaman and Nicobar Islands </h3>
          </div>
          <div className="lang-card">
            <h2>Language spoken </h2>
            <h3> Kashmiri </h3>
            <h3> Hindi </h3>
            <h3> Punjab </h3>
            <h3> Hindi</h3>
            <h3> Hindi</h3>
            <h3> Hindi </h3>
            <h3> Hindi </h3>
            <h3> Hindi </h3>
            <h3> Hindi </h3>
            <h3> Hindi </h3>
            <h3> Hindi </h3>
            <h3> Hindi </h3>
            <h3> Bengali </h3>
            <h3> Nepali </h3>
            <h3> Assamese </h3>
            <h3> Bengali </h3>
            <h3> Bengali </h3>
            <h3> Bengali </h3>
            <h3> Bengali </h3>
            <h3> Bengali </h3>
            <h3> Manipuri </h3>
            <h3> Oriya</h3>
            <h3> Marathi </h3>
            <h3> Gujarati </h3>
            <h3> Gujarati </h3>
            <h3> Gujarati </h3>
            <h3> Konkani </h3>
            <h3> Kannada </h3>
            <h3> Telugu </h3>
            <h3> Malayalam </h3>
            <h3> Malayalam </h3>
            <h3> Tamil </h3>
            <h3> Tamil </h3>
            <h3> Bengali </h3>
          </div>
          <div className="lang-card">
            <h2>Other languages spoken </h2>
            <h3> Dogri and Hindi </h3>
            <h3> 	Punjabi and Nepali </h3>
            <h3> Hindi </h3>
            <h3>Urdu, Punjabi and Nepali </h3>
            <h3> Punjabi and Urdu </h3>
            <h3> Punjabi, Urdu and Bengali </h3>
            <h3> 	Urdu </h3>
            <h3>	Punjabi and Urdu  </h3>
            <h3> Marathi and Urdu </h3>
            <h3> Bengali and Oriya </h3>
            <h3> Maithili and Urdu </h3>
            <h3> Santali, Bengali and Urdu </h3>
            <h3> Hindi, Santali, Urdu, Nepali </h3>
            <h3> 	Hindi, Bengali </h3>
            <h3> 	Bengali, Hindi, Nepali</h3>
            <h3> Nepali, Hindi and Assamese </h3>
        
            <h3> Hindi and Nepali </h3>
            <h3> Hindi and Nepali </h3>

            <h3> Hindi</h3>
            <h3> Hindi and Nepali </h3>
            <h3> Nepali, Hindi and Bengali </h3>
            <h3> Hindi, Telegu and Santali </h3>
            <h3> 	Hindi, Urdu and Gujarati </h3>
            <h3> 	Hindi, Sindhi, Marathi ,Urdu </h3>
            <h3> Hindi and Marathi </h3>
            <h3> Hindi, Konkani and Marathi </h3>
            <h3> 	Marathi, Hindi and Kannada</h3>
            <h3> Urdu, Telugu, Marathi ,Tamil</h3>
            <h3> 	Urdu, Hindi and Tamil </h3>
            <h3> - </h3>
            <h3>- </h3>
            <h3> 	Telugu, Kannada and Urdu </h3>
            <h3> 	Telugu, Kannada and Urdu </h3>
            <h3> Tamil,Telugu, Malayalam</h3>
      
          </div>
        </div>
      </div>
    </>
  );
}

export default Lang;
